import { Appointment, AppointmentStatus } from "types";

const filterAppointmentsByStatus = (
  appointments: Appointment[],
  status: AppointmentStatus
) => {
  return appointments.filter((appointment) => {
    return appointment.status === status;
  });
};

export { filterAppointmentsByStatus };
